export default "__VITE_ASSET__Cnrr7noJ__"